export default "__VITE_ASSET__daf3218c__"